import React, { useEffect, useRef, useState } from "react";
import styles from "../pricingList/PricingList.module.scss";
import CheckBox from "../../../../shared/checkBox/CheckBox";
import Item from "../../../../shared/item/Item";
import { TextValidator } from "react-material-ui-form-validator";
import CheckCurrencyValue from "../../../../utils/CheckCurrencyValue";
import { Table, TableHead, Tooltip } from "@material-ui/core";
import {
  CheckBoxTableCell,
  NonEditTableCell,
  SpecsTableCellPricingDetails,
  WarningTableCell,
} from "../../../../shared/pricing/dealerFees/TableComponents";
import PositiveValue from "../../../../utils/PostiveValue";
import {
  ReactComponent as KeyboardArrowDown,
  ReactComponent as KeyboardArrowUp,
} from "../../../../imgs/chevron-down-blue.svg";
import DealerDiscountTooltip from "../pricingRow/dealerDiscountTooltip/DealerDiscountTooltip";
import { withStyles } from "@material-ui/core/styles";
import { CHARGE, DISCOUNT, NONE } from "../../../../common/Constants";
import HasPermissionTo from "../../../../common/HasPermissionTo";

const StyledTooltip = withStyles({
  popper: {
    opacity: 1,
    pointerEvents: "auto",
  },
  tooltip: {
    background: "white",
    boxShadow: "1px 1px 9px 0 rgba(0, 0, 0, 0.27)",
    paddingTop: 28,
    paddingLeft: 28,
    paddingRight: 28,
    paddingBottom: 18,
    maxWidth: 375,
  },
})(Tooltip);

const OptionsRow = (props) => {
  function moveSignToTheLeft(value) {
    let result = "";
    if (value < 0) {
      const signRemovedString = value.toString().replace("-", "");
      result =
        "-" + CheckCurrencyValue(props.currencySymbol, signRemovedString);
    } else {
      result = CheckCurrencyValue(props.currencySymbol, value);
    }
    return result;
  }

  const dealerDiscount = PositiveValue(props.optionsData.adj);
  const dealerDiscountDisplay = CheckCurrencyValue(
    props.currencySymbol,
    dealerDiscount
  );

  const [openEditBox, setOpenEditBox] = useState(false);
  const [dropDownExpanded, setDropDownExpanded] = useState(false);
  const [valueDropDown, setValueDropDown] = useState(
    props.optionsData.optionsAdjType
  );
  const dropDownRef = useRef(null);

  useEffect(() => {
    if (props.individualEditIndex === -1 && openEditBox) {
      setOpenEditBox(false);
    }
  }, [props.individualEditIndex]);

  useEffect(() => {
    setValueDropDown(props.optionsData.optionsAdjType);
  }, [props.optionsData.optionsAdjType]);

  function toggleEditBox() {
    setOpenEditBox(true);
    props.updateEnabledIndividualEdit(true);
  }

  function rowCheck(editedListed) {
    let checkedMark = false;

    for (const value of editedListed) {
      if (value === props.optionsData.featureDesc) {
        checkedMark = true;
      }
    }
    return checkedMark;
  }

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropDownRef.current && !dropDownRef.current.contains(event.target)) {
        setDropDownExpanded(false);
      }
    }

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropDownRef]);

  return (
    <div
      className={`${
        props.isNsc
          ? styles.rowBorderHighlight
          : props.optionsData.released
          ? styles.rowBorderHighlight
          : styles.rowBorderHighlightPriceChange
      } ${
        props.optionsData.released &&
        props.editChecked &&
        rowCheck(props.rowOptionsEditedCheckbox)
          ? styles.rowBorderHighlightPriceEdited
          : styles.rowBorderHighlight
      } ${styles.rowBorderHighlight}`}
    >
      <Table>
        <TableHead>
          <WarningTableCell>
            {!props.isNsc && !props.optionsData.released ? (
              <div
                className={styles.warning}
                data-testid={"warning" + props.index}
              />
            ) : (
              <div>
                {props.newlyReleased ? (
                  <div
                    className={styles.success}
                    data-testid={"success" + props.index}
                  />
                ) : props.rowEditSaved &&
                  rowCheck(props.rowOptionsEditedCheckbox) ? (
                  <div
                    className={styles.success}
                    data-testid={"success" + props.index}
                  />
                ) : (
                  ""
                )}
              </div>
            )}
          </WarningTableCell>

          <CheckBoxTableCell>
            <CheckBox
              id={"toggleCheckbox" + props.index}
              checked={
                (!props.optionsData.released && !props.viewOnlyPricing) ||
                (props.editChecked && rowCheck(props.rowOptionsEditedCheckbox))
              }
              isDisabled={props.isDisabled}
            />
          </CheckBoxTableCell>

          <SpecsTableCellPricingDetails>
            <Item value={props.optionsData.featureDesc} />
          </SpecsTableCellPricingDetails>

          <NonEditTableCell
            className={`${styles.rowItemBold} ${styles.center}`}
          >
            <Item
              datatestid={"year" + props.index}
              value={props.optionsData.year}
            />
          </NonEditTableCell>
          <NonEditTableCell
            className={`${styles.rowItemBold} ${styles.center}`}
          >
            <Item
              datatestid={"rrp" + props.index}
              value={CheckCurrencyValue(
                props.currencySymbol,
                props.optionsData.rrp
              )}
            />
          </NonEditTableCell>

          <NonEditTableCell
            className={`${styles.rowItemBold} ${styles.center}`}
          >
            <Item
              datatestid={"dealerDiscount" + props.index}
              value={CheckCurrencyValue(
                props.currencySymbol,
                props.optionsData.vm
              )}
            />
          </NonEditTableCell>

          <HasPermissionTo
            perform={["dealerAdjustment"]}
            permissions={props.user.permissions.rolePermissions}
            render={() => {
              return (
                <NonEditTableCell
                  className={`${styles.rowItemBold} ${styles.center}`}
                >
                  {props.isEditEnabled ||
                  (openEditBox && props.individualEditIndex === props.index) ? (
                    <div className={styles.validCurrency}>
                      <div ref={dropDownRef}>
                        <button
                          className={styles.dropdownButton}
                          type="button"
                          onClick={() => {
                            setDropDownExpanded(!dropDownExpanded);
                          }}
                        >
                          <span>
                            {valueDropDown === NONE ? (
                              <span className={styles.blankDash}></span>
                            ) : valueDropDown === CHARGE ? (
                              "+" +
                              CheckCurrencyValue(props.currencySymbol, 0).slice(
                                0,
                                -1
                              )
                            ) : valueDropDown === DISCOUNT ? (
                              "-" +
                              CheckCurrencyValue(props.currencySymbol, 0).slice(
                                0,
                                -1
                              )
                            ) : (
                              " "
                            )}
                          </span>

                          {!dropDownExpanded ? (
                            <KeyboardArrowDown
                              className={styles.dropDownArrow}
                            ></KeyboardArrowDown>
                          ) : (
                            <KeyboardArrowUp
                              className={styles.dropDownArrowUp}
                            ></KeyboardArrowUp>
                          )}
                        </button>

                        {dropDownExpanded && (
                          <div className={styles.dealerAdjustmentDropdown}>
                            <ul className={styles.optionsUl}>
                              <li
                                onClick={() => {
                                  setValueDropDown(NONE);
                                  setDropDownExpanded(false);
                                  props.updateAdjustmentPrice(
                                    null,
                                    props.index,
                                    NONE
                                  );
                                }}
                              >
                                <p>{props.t("CurrentPricing.none")}</p>
                              </li>
                              <li
                                onClick={() => {
                                  setValueDropDown(CHARGE);
                                  setDropDownExpanded(false);
                                  props.updateAdjustmentPrice(
                                    null,
                                    props.index,
                                    CHARGE
                                  );
                                }}
                              >
                                <p>{props.t("CurrentPricing.charge")}</p>
                              </li>
                              <li
                                onClick={() => {
                                  setValueDropDown(DISCOUNT);
                                  setDropDownExpanded(false);
                                  props.updateAdjustmentPrice(
                                    null,
                                    props.index,
                                    DISCOUNT
                                  );
                                }}
                              >
                                <p>{props.t("CurrentPricing.discount")}</p>
                              </li>
                            </ul>
                          </div>
                        )}
                      </div>

                      <div className={styles.textBox}>
                        <TextValidator
                          name="adjustmentInput"
                          value={
                            valueDropDown === NONE
                              ? 0
                              : PositiveValue(props.optionsData.adj).toString()
                          }
                          disabled={valueDropDown === NONE}
                          data-testid={"adjustmentInput" + props.index}
                          validators={[
                            "required",
                            "isNumericWithBigDecimal",
                            "maxNumber:" + `${props.optionsData.rrp}`,
                            "minNumber:" + `${-props.optionsData.rrp}`,
                          ]}
                          errorMessages={[
                            props.t("Error.requiredField"),
                            props.t("Error.invalidInput"),
                            props.t("PricingRow.errorMaximum"),
                            props.t("PricingRow.errorMinimum"),
                          ]}
                          onChange={(e) => {
                            props.updateAdjustmentPrice(
                              e.target.value,
                              props.index,
                              null
                            );
                          }}
                        />
                      </div>
                    </div>
                  ) : (
                    <>
                      <Item
                        className={
                          props.optionsData.optionsAdjType === NONE
                            ? styles.normal
                            : props.optionsData.optionsAdjType === DISCOUNT
                            ? styles.discount
                            : styles.charge
                        }
                        datatestid={"adjustmentAmount" + props.index}
                        value={
                          props.optionsData.optionsAdjType === NONE
                            ? dealerDiscountDisplay
                            : props.optionsData.optionsAdjType === DISCOUNT
                            ? "-" + dealerDiscountDisplay
                            : "+" + dealerDiscountDisplay
                        }
                      />
                      <HasPermissionTo
                        permissions={props.user.permissions.rolePermissions}
                        perform={["vehiclePricing:write"]}
                        render={() => (
                          <StyledTooltip
                            open={props.individualEditIndex === props.index}
                            placement="bottom-start"
                            title={
                              <DealerDiscountTooltip
                                toggleEditBox={toggleEditBox}
                                updateIndividualEditIndex={
                                  props.updateIndividualEditIndex
                                }
                                adjustment={props.optionsData.adj}
                                recommendedAdjustment={0}
                                resetOptionsRow={props.resetOptionsRow}
                                index={props.index}
                                {...props}
                              />
                            }
                          >
                            <span
                              className={
                                (props.optionsData.rrp >
                                  props.optionsData.adj ||
                                  props.optionsData.rrp <
                                    props.optionsData.adj) &&
                                props.optionsData.adj !== 0
                                  ? styles.reset
                                  : ""
                              }
                              data-testid={"reset" + props.index}
                              onClick={() =>
                                props.updateIndividualEditIndex(props.index)
                              }
                            >
                              &nbsp;
                            </span>
                          </StyledTooltip>
                        )}
                      />
                    </>
                  )}
                </NonEditTableCell>
              );
            }}
          />

          <NonEditTableCell
            className={`${styles.rowItemBold} ${styles.center}`}
          >
            <Item
              data-testid={"recommendedPrice" + props.index}
              value={moveSignToTheLeft(props.optionsData.recommendedPrice)}
            />
          </NonEditTableCell>
        </TableHead>
      </Table>
    </div>
  );
};
export default OptionsRow;
